/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const budgetPredictionResultsSchema = z.object({
	recommendedBudget: z.number().nullable(),
})

export type BudgetPredictionResultsSchema = z.infer<typeof budgetPredictionResultsSchema>
